<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Quoteo } from '#library/components.schema.build.ts'
	import Video from '#components/video.svelte'
	import Image from '#components/image.svelte'

	interface Props {
		blok: Blok<Quoteo>
	}

	let { blok }: Props = $props()
</script>

<section class="quoteo {blok.theme}" {...attrs(blok)}>
	<div class="contain">
		<div class="content">
			<svg class="mark">
				<use xlink:href="/images/vector.svg#quote"></use>
			</svg>
			<div>
				<div class="title">{blok.title}</div>
				<div class="subtitle">{blok.subtitle}</div>
			</div>
		</div>
		<div class="video">
			{#if blok.video?.m3u8_url}
				<Video video={blok.video} portrait />
			{:else if blok.image?.filename}
				<Image src={blok.image.filename} alt={blok.image.alt} focus={blok.image.focus} aspect="3/4" />
			{/if}
		</div>
	</div>
</section>

<style lang="css">
	.quoteo {
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
		overflow: visible;
	}

	.contain {
		background-color: var(--c-white);
		gap: 2.5rem;
		display: grid;
		padding: 1rem;

		@media (--from-tablet) {
			grid-template-columns: repeat(12, 1fr);
			margin-block-start: 4.5rem;
			padding-block: var(--s-96);
		}
	}

	.video {
		@media (--from-tablet) {
			grid-column: 2 / span 4;
			margin-block-start: -10rem;
			order: -1;
		}
	}

	.content {
		display: flex;
		flex-direction: column;
		gap: 1rem;

		@media (--from-tablet) {
			flex-direction: row;
			gap: 2rem;
			grid-column: 6 / span 7;
			max-width: 50ch;
		}
	}

	.mark {
		color: var(--c-foreground);
		flex: 0 0 auto;
		size: 1.5rem 1.5rem;

		@media (--from-tablet) {
			size: 2.5rem 2.25rem;
		}
	}

	.title {
		color: var(--c-midground);
		font: 400 var(--f-h4);
		letter-spacing: var(--ls-h4);
	}

	.subtitle {
		color: var(--c-foreground);
		font: 400 var(--f-h6);
		letter-spacing: var(--ls-h6);
		margin-block-start: 1.5rem;
	}
</style>
